import { MultiSelectElement } from 'react-hook-form-mui';

export default MultiSelectElement;
